document.addEventListener("turbolinks:load", function() {
  _.each($('input[data-mask]'), function(elem) {
    $(elem).mask(elem.dataset['mask'])
  });
});
